import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MenuService from "../services/menuService";
import { useSlug } from "../pages/hooks/UseSlug";

const menuService = new MenuService();

export const useVerificaPermissao = () => {
  const [loadingPermissao, setLoadingPermissao] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const slug = useSlug();

  useEffect(() => {
    const rotasPublicas = ['/sem-permissao', '/login', '/trocar-senha', '/home'];

    const verificaPermissaoPaginaUsuario = async () => {
      setLoadingPermissao(true);
      try {
        let rotaParaVerificar = location.pathname;

        if (slug && rotaParaVerificar.startsWith(`/${slug}`)) {
          rotaParaVerificar = rotaParaVerificar.substring(slug.length + 1);
        }

        if (!rotaParaVerificar.startsWith('/')) {
          rotaParaVerificar = '/' + rotaParaVerificar;
        }

        if (rotaParaVerificar === "/") {
          rotaParaVerificar = "/home";
        }

        if (rotasPublicas.includes(rotaParaVerificar)) {
          setLoadingPermissao(false);
          return;
        }

        const temPermissao = await menuService.verificaPermissaoPaginaPorRole(rotaParaVerificar);
        
        if (!temPermissao.data) {
          const redirectPath = slug ? `/${slug}/sem-permissao` : '/sem-permissao';
          navigate(redirectPath);
        }
      } catch (error) {
        const redirectPath = slug ? `/${slug}/sem-permissao` : '/sem-permissao';
        navigate(redirectPath);
      } finally {
        setLoadingPermissao(false);
      }
    };

    verificaPermissaoPaginaUsuario();

  }, [location.pathname, navigate, slug]);

  return { loadingPermissao };
};